import axios from "axios";
import { API_BASE } from "../config/api";

export const normalizeIndianPhone = (phone) => {
  const digits = String(phone || "").replace(/\D/g, "");

  if (digits.length === 10) {
    return digits;
  }

  if (digits.length === 12 && digits.startsWith("91")) {
    return digits.slice(2);
  }

  throw new Error("Please enter a valid 10-digit phone number.");
};

export const sendSMSOtp = async (phone, purpose = "") => {
  const normalizedPhone = normalizeIndianPhone(phone);

  await axios.post(`${API_BASE}/v1/user/send-otp-sms`, {
    phone: normalizedPhone,
    ...(purpose ? { purpose } : {}),
  });

  return normalizedPhone;
};

export const verifySMSOtp = async ({ phone, otp, purpose = "", registrationData = null }) => {
  const normalizedPhone = normalizeIndianPhone(phone);

  return axios.post(
    `${API_BASE}/v1/user/verify-otp-sms`,
    {
      phone: normalizedPhone,
      otp: String(otp || "").trim(),
      ...(purpose ? { purpose } : {}),
      ...(registrationData || {}),
    },
    { withCredentials: true }
  );
};

export const resetSMSOtpState = () => {};
